var _a;
import { useMemo } from 'react';
var AVAILABLE = 'Available';
var UNAVAILABLE = 'Unavailable';
var ERROR_COLOR = '#E22020';
var SUCCESS_COLOR = '#266B49';
var DEFAULT_COLOR = '#000000ff';
var STATE_CONFIGS = (_a = {},
    _a[AVAILABLE] = { color: SUCCESS_COLOR, status: 'success' },
    _a[UNAVAILABLE] = { color: ERROR_COLOR, status: 'error' },
    _a);
var DEFAULT_CONFIG = { color: DEFAULT_COLOR, status: null };
var getStateConfig = function (state) {
    return STATE_CONFIGS[state] || DEFAULT_CONFIG;
};
export var useAgentState = function (agentStatus) {
    var _a, _b;
    return useMemo(function () {
        var _a, _b;
        var currentState = (_a = agentStatus === null || agentStatus === void 0 ? void 0 : agentStatus.agentStateData) === null || _a === void 0 ? void 0 : _a.CurrentState;
        var currentReason = (_b = agentStatus === null || agentStatus === void 0 ? void 0 : agentStatus.agentStateData) === null || _b === void 0 ? void 0 : _b.CurrentOutReason;
        var selectedKey = (function () {
            if (!currentState)
                return [];
            if (currentState.toLowerCase() === 'unavailable' && currentReason) {
                return [currentReason];
            }
            return [currentState.toLowerCase()];
        })();
        var label = "".concat(currentState || 'Initialization...').concat(currentReason ? ": ".concat(currentReason) : '');
        var config = getStateConfig(currentState);
        return {
            currentState: currentState,
            currentReason: currentReason,
            selectedKey: selectedKey,
            label: label,
            statusColor: config.color,
            badgeStatus: config.status
        };
    }, [
        (_a = agentStatus === null || agentStatus === void 0 ? void 0 : agentStatus.agentStateData) === null || _a === void 0 ? void 0 : _a.CurrentState,
        (_b = agentStatus === null || agentStatus === void 0 ? void 0 : agentStatus.agentStateData) === null || _b === void 0 ? void 0 : _b.CurrentOutReason
    ]);
};
